import { getNumber } from '../numeral';

export const integer = (value: string | number): number => {
  if (/^[-+]?(\d+|Infinity)$/.test(String(value))) {
    return Number(value);
  }
  return Number(String(value).replace(/\D/g, ''));
};

export const decimal =
  (
    numberOfDecimals: number,
    roundingFunction: (x: number) => number = Math.round
  ) =>
  (value: string | number): number => {
    const number = getNumber(value);
    return (
      roundingFunction(number * 10 ** numberOfDecimals) / 10 ** numberOfDecimals
    );
  };

export const phoneNumber = (value: string | null | undefined): string =>
  value ? `+${String(value).replace(/\D/g, '')}` : '';

export {
  phoneNumber as normalizePhoneNumber,
  decimal as normalizeDecimal,
  integer as normalizeInteger
};
